import React from "react";

import {
  ErrorBoundary,
  withErrorBoundary,
} from "@liftoff/components/ErrorBoundary";

import { reportError } from "./utils";

// @ts-expect-error TS7006 Adopt TS
export const formatComponentStack = (componentStack) => {
  try {
    return (
      componentStack
        .split("\n")
        // Filter out noisy minimized component names like 'in N'
        // @ts-expect-error TS7006 Adopt TS
        .filter((l) => !/in [a-zA-Z]$/.test(l))
        .join("\n")
    );
    // biome-ignore lint/correctness/noUnusedVariables: Biome linting adoption
  } catch (e) {
    return `Failed to format component stack\n${componentStack}`;
  }
};

// @ts-expect-error TS7006 Adopt TS
export const defaultErrorHandler = (error, { componentStack }) =>
  // @ts-expect-error TS2554 Adopt TS
  reportError(`Error Boundary: ${formatComponentStack(componentStack)}`, error);

// @ts-expect-error TS7031 Adopt TS
export const DefaultErrorBoundary = ({ children }) => (
  <ErrorBoundary handleError={defaultErrorHandler}>{children}</ErrorBoundary>
);

/**
 * An error boundary configured to report client errors and hide the component.
 */
export const withDefaultErrorBoundary = withErrorBoundary({
  // @ts-expect-error TS2322 Adopt TS
  collapseOnError: true,
  // @ts-expect-error TS2322 Adopt TS
  handleError: defaultErrorHandler,
});
